import React from 'react';

import { AUDIT_STATUS_FILTER_ORDER, AuditStatus, AuditStatusNames } from 'core/constants';

import { AuditStatusSelectProps } from './types';
import { StyledMenuItem, StyledSelect } from '../styles';
import { Text } from './styles';

const AuditStatusSelect: React.FunctionComponent<AuditStatusSelectProps> = ({ onChange, ...props }) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as AuditStatus)}>
    {AUDIT_STATUS_FILTER_ORDER.map((status) => (
      <StyledMenuItem key={status} value={status}>
        <Text>{AuditStatusNames[status]}</Text>
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default AuditStatusSelect;
